export const OPEN_API_BASE_PATH = '/openapi'
export const CUSTOM_API_TYPE = 'SEARCH_COMPANY_JOB_LIST'
